
export const POPULAR_CATEGORIES = [
	{ name: "Wallpapers", slug: "wallpapers" },
	{ name: "Business & Work", slug: "business-work" },
	{ name: "Interiors", slug: "interiors" },
	{ name: "Animals", slug: "animals" },
	{ name: "Nature", slug: "nature" },
	{ name: "Experimental", slug: "experimental" },
	{ name: "Fashion", slug: "fashion" },
	{ name: "Film", slug: "film" },
	{ name: "Health & Wellness", slug: "health" },
	{ name: "Street Photography", slug: "street-photography" },
	{ name: "Technology", slug: "technology" },
	{ name: "Travel", slug: "travel" },
	{ name: "Textures & Patterns", slug: "textures-patterns" },
	{ name: "Food & Drink", slug: "food-drink" },
	{ name: "Athletics", slug: "athletics" },
	{ name: "Spirituality", slug: "spirituality" },
	{ name: "Arts & Culture", slug: "arts-culture" },
	{ name: "Current Events", slug: "current-events" },
	{ name: "Architecture", slug: "architecture" },
	{ name: "People", slug: "people" },
].sort((a, b) => a.name > b.name ? 1 : -1);

export const EDITORIAL_SLUG = "editorial";

POPULAR_CATEGORIES.unshift({ // add Editorial category at the beggining of the dropdown
	name: "Editorial", slug: EDITORIAL_SLUG
});

export const HOME_PAGE_SEARCH_PARAMS = {
	page: 1,
	per_page: 8,
};

export const DEFAULT_PAGE_SIZE = 30;

export const ROUTES = {
	HOME: "",
	SEARCH: "search",
	SUMMARY: "summary",
};

export const SORT_OPTIONS = {
	topic: ["latest", "oldest", "popular"],
	search: ["relevant", "latest"],
};
export const SORT_OPTIONS_DEFAULT = {
	topic: "latest",
	search: "relevant",
};

export const ORIENTATION_OPTIONS = ["landscape", "portrait", "squarish"];

export const COLOR_OPTIONS = [
	{ hex: "#f44f3b", value: "red"},
	{ hex: "#fe9202", value: "orange"},
	{ hex: "#fcdc00", value: "yellow"},
	{ hex: "#a4dd00", value: "green"},
	{ hex: "#69ccca", value: "teal"},
	{ hex: "#459ada", value: "blue"},
	{ hex: "#7b64ff", value: "purple"},
	{ hex: "#ab149e", value: "magenta"},
	{ hex: "#fff", value: "white"},
	{ hex: "#000", value: "black"},
];

export const DATE_FORMAT = "MMMM d, y";

export const COLOR_OPTIONS_RAW = COLOR_OPTIONS.map((color) => color.hex);

export const COLORS_MAP = COLOR_OPTIONS.reduce((acc, prev) => {
	acc[prev.value] = prev.hex;
	return acc;
},{});

export const HOME_PAGE_PARAMS = {
	page: 1,
	perPage: 4
};

export const IMAGE_SIZE_OPTIONS = [
	{
		name: "small",
		height: 640,
	},
	{
		name: "medium",
		height: 1920,
	},
	{
		name: "large",
		height: 2400,
	},
];

export const COLOR_TYPE_BLACK_AND_WHITE = "black_and_white";
export const COLOR_TYPE_TONES = "tones";

export const COLOR_TYPES_OPTIONS = [COLOR_TYPE_BLACK_AND_WHITE, COLOR_TYPE_TONES];

export const LICENSE_URL = "https://unsplash.com/license";


